import React from 'react';
import rightArrowIcon from '../../assets/images/righArrowIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { DQBElement } from '../../types/DQB';
import { setDQBOpen } from '../../features/DQB/DQBOpenSlice';
import { useOpenDqbMutation } from '../../api/open-dqb';

interface DQBItemProps {
    dqbItem: DQBElement;
    bookId: any;
}

const DQBItem: React.FC<DQBItemProps> = ({ dqbItem, bookId }) => {
    const dispatch = useDispatch();

    const [
        getOpenDqb,
        { isLoading: isDqbOpenLoading, isError: isDqbOpenError },
    ] = useOpenDqbMutation();
    const handleClick = () => {
        dispatch(setDQBOpen(false));
        getOpenDqb({ book_id: bookId })
            .unwrap() // This ensures we get the result of the mutation (or an error)
            .then((response: any) => {
                // Handle successful launch response
                console.log('DQB successful:', response);
            })
            .catch((error: any) => {
                // Handle error
                console.error('DQB failed:', error);
            });
    };

    return (
        <div className="chapter-item px-6 py-3 hover:bg-[#F7F9FD]">
            <button
                data-testid="dqb-chapter-item-button"
                onClick={handleClick}
                className="w-full h-12 bg-transparent rounded text-black flex flex-row justify-between text-md items-center"
            >
                <div className="flex flex-row items-center">
                    <span className={` text-lg `}>{dqbItem.title}</span>
                </div>
                <div className="flex flex-row items-center">
                    <span className="pl-20 pr-4">
                        <img src={rightArrowIcon} alt="right arrow icon" />
                    </span>
                </div>
            </button>
        </div>
    );
};

export default DQBItem;
